module.exports = __webpack_public_path__ + "img/noWingsOwl.02ca2d1c.svg";